import cx from 'classnames';
import React from 'react';
export const FormItem = ({ children, className, density, disabled, error, indentation, is: Tag = 'div', wrapperRef, ...rest }) => (React.createElement(Tag, { className: cx('tds-form-item', {
        [`tds-density--${density}`]: density,
        'tds--disabled': disabled,
        [`tds-form--${indentation}`]: indentation,
        'tds-form--error': error,
    }, className), 
    // @ts-expect-error - TS expects either a div or a legend element and can't infer the type from usage
    ref: wrapperRef, ...rest }, children));
